module.exports = __webpack_public_path__ + "img/icon_e66.02d19ae6.png";